import {
  Card,
  CardBody,
  Timeline,
  TimelineBody,
  TimelineHeader,
  TimelineItem,
  Typography,
} from "@material-tailwind/react";
import redLine from "../../assets/images/redLine.png";
import { ImLocation2 } from "react-icons/im";
import { MdOutlineCircle } from "react-icons/md";

interface HireCardProps {
  boatId: string;
  tripStatus: string;
  selected: boolean;
  onClick: () => void;
}

function HireCard({ boatId, tripStatus, selected, onClick }: HireCardProps) {
  return (
    <Card  placeholder={undefined} onClick={() => onClick()} className="w-full mb-6">
      <CardBody  placeholder={undefined} className="flex">
        {selected && <img src={redLine} className="pr-3" />}
        <div className="w-full">
          <div className=" flex justify-between w-full">
            <p className="flex">
              Boat ID:
              <span className="font-bold ml-2">{boatId}</span>
            </p>
            <p className="text-xs bg-[#DEF8EC] text-green-600 p-1 rounded-md ">
              {tripStatus}
            </p>
          </div>
          <Timeline className="mt-8 ">
            <TimelineItem>
              <hr className=" border-dotted h-24 border-l-2 border-l-gray-500 border-l-dotted absolute left-2 " />
              <TimelineHeader className="h-3">
                <MdOutlineCircle
                  className="bg-white z-0"
                  size={20}
                  color="red"
                />
                <Typography placeholder={undefined}  className="font-medium">
                  Lagos Island, sandfield pick up
                </Typography>
              </TimelineHeader>
              <TimelineBody className=" pb-16" />
            </TimelineItem>
            <TimelineItem>
              <TimelineHeader className="h-3">
                <ImLocation2 color="green" size={20} className="bg-white z-0" />
                <Typography placeholder={undefined}  color="blue-gray" className="font-medium">
                  Badagry, lamaga drop off
                </Typography>
              </TimelineHeader>
            </TimelineItem>
          </Timeline>
        </div>
      </CardBody>
    </Card>
  );
}

export default HireCard;
